import localStore from '@/wrappers/localstore.js'

const storage = localStore.namespace('assetsmap')

export default storage



// WEBPACK FOOTER //
// ./src/localstorage/assetsMap.localstorage.js